import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, addData, updateData, deleteData, getpastWebinarYears } from '../../services/webinarVideoServices';
import { Modal, Button, Form } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';

const Videosgallery = () => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({}); 
  const [dataList, setDataList] = useState([]);
  const [form, setForm] = useState({ id: '', year: '', webinar_order: '', webinar_code: '', webinar_title: '', webinar_aff: '' });
  const [modalType, setModalType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pastWebinarYears, setpastWebinarYears] = useState([]);
  

  // Fetch data list
  const fetchData = useCallback(async () => {
    setLoading(true); 
    try{
    const data = await getData();
    setDataList(data);
    }
    catch (error) {
    console.error('Failed to fetch data:', error);
  }
  finally {
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const validateForm = () => {
    const newErrors = {};
    if (!form.year) newErrors.year = "Year  is required";  
    if (!form.webinar_order) newErrors.webinar_order = "Order  is required";  
    if (!form.webinar_code) newErrors.webinar_code = "Youtube Code  is required";  
    if (!form.webinar_title) newErrors.webinar_title = "Webinar Title is required";
    if (!form.webinar_aff) newErrors.webinar_aff = "Webinar Affilation is required";
    if (form.webinar_code && !/^[a-zA-Z0-9_-]{11}$/.test(form.webinar_code)) {
      newErrors.webinar_code = "Invalid YouTube video code";
    }
    if (form.webinar_order && !/^[0-9]+$/.test(form.webinar_order)) {
      newErrors.webinar_order = "Order must be a number";
    }

    setErrors((prev) => ({ ...prev, ...newErrors }));
    return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);
  };

   useEffect(() => {
        const fetchpastWebinarYears = async () => {
          try {
            const data = await getpastWebinarYears(); // Fetch data from the service
            setpastWebinarYears(data); // Set the types in state
          } catch (error) {
            console.error('Error fetching data:', error);
          }
        };
     
        fetchpastWebinarYears();
      }, []);

 

  const handleChange = (e) => {
    try{
    const { name, value } = e.target;
    let updatedErrors = { ...errors };
    setForm((prev) => ({ ...prev, [name]: value }));
     if (value) {
        updatedErrors[name] = ''; // Clear error if corrected
      }
    // Validate the field 
    if (name === 'webinar_order' && !/^[0-9]+$/.test(value)) {
      updatedErrors.webinar_order = "Order must be a number";   
    } else if (name === 'webinar_code' && !/^[a-zA-Z0-9_-]{11}$/.test(value)) { 
      updatedErrors.webinar_code = "Invalid YouTube video code";
    }
      setErrors(updatedErrors);
    }
    catch (error) {
      console.error('Error in handleChange:', error);
    } 
  };

  const handleSubmit = async (e) => {
    try{
      e.preventDefault();
      if (!validateForm()) {
          return
        }
      let result;
      if (modalType === 'add') {
        result = await addData(form);
      } else if (modalType === 'edit') {
        result = await updateData(form);
      }
      if (result?.status === 200||201) {
          fetchData();  // Re-fetch data after adding/editing
          setShowModal(false);
          toast.success("saved successfully!", {position: 'top-right',});}
      else {
      toast.error(result.message ||"Failed to update data. Please try again.", {position: 'top-right'});
          }
      }
    catch (error) {   
      console.error('Error during form submission:', error);
    }
  };

  const handleDelete = async () => {
    try{
    if (selectedData) {
      // Optimistically remove the data from the list
      setDataList((prev) => prev.filter((data) => data.id !== selectedData.id));
      // Proceed with the actual delete request
      await deleteData(selectedData);
      setShowDeleteConfirmModal(false);
      toast.success("Deleted successfully!", {position: 'top-right',autoClose: 3000});
    }
  }
  catch(error){
        console.error('Failed to delete getData:', error);
      };
  };

  const openModal = (type, data = { id: '', year: '', webinar_order: '', webinar_code: '', webinar_title: '', webinar_aff: '' }) => {
    setModalType(type);
    setForm(data);
    setShowModal(true);
  };
  
  const openDeleteConfirmModal = (data) => {
    setSelectedData(data);
    setShowDeleteConfirmModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Memoized filtered data based on search query
  const filteredData = useMemo(() => {
    const  filtered =  dataList?.filter(
      (data) =>
      data.webinar_title.toLowerCase().includes(searchText.toLowerCase()) ||
      data.webinar_aff.toLowerCase().includes(searchText.toLowerCase())
    );
    const sortedData = [...filtered].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
    return sortedData;
  }, [dataList, searchText]);

  const columns = [
    {
      name: '#',
      selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
      sortable: false,
      width: '80px',
    },
    {
      name: 'year',
      selector: (row) => row.year,
      cell: (row) => (
            <span title={row.year}>
              {row.year}
            </span>
          ),
      sortable: true,
    },
    {
      name: 'Webinar Title',
      selector: (row) => row.webinar_title,
      cell: (row) => (
            <span title={row.webinar_title}>
              {row.webinar_title}
            </span>
          ),
      sortable: true,
    },
    {
      name: 'Webinar Affilation',
      selector: (row) => row.webinar_aff,
      cell: (row) => (
            <span title={row.webinar_aff}>
              {row.webinar_aff}
            </span>
          ),
      sortable: true,
    },
    {
      name: 'Actions',
      cell: (row) => (
        <div>
          <Button className="me-2" variant="warning" size="sm" onClick={() => openModal('edit', row)} > Edit </Button>
          <Button variant="danger" size="sm" onClick={() => openDeleteConfirmModal(row)} > Delete </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className='mb-3 fs-4'>Past Events Pages / Past Webinar <b>/ Webinar Videos</b></p>
            </div>
            <div className="col-4 text-end">
              <button className="btn btn-primary mb-3 form-label-custom" onClick={() => openModal('add')}>
                Add
              </button>
            </div>
          </div>

          {/* Data Table for data */}
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationComponentOptions={{
            noRowsPerPage: true,
            }}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }
          />

          {/* Modal for Add/Edit data */}
          <Modal className="modal-lg" show={showModal} onHide={() => setShowModal(false)} backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title className='fs-3'>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
              <div className="row">

              <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Webinar Order <small className='text-danger'> * </small></Form.Label>
                  <Form.Control type="text" name="webinar_order" value={form.webinar_order} onChange={handleChange}  isInvalid={!!errors.webinar_order}/>
                  <Form.Control.Feedback type="invalid">{errors.webinar_order}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-6 mb-3">
                <Form.Label className='form-label-custom'>Past Webinar Year <small className='text-danger'> * </small></Form.Label>
                <Form.Control className="form-select mb-3" as="select" name="year" value={form.year} onChange={handleChange} isInvalid={!!errors.year} >
                    <option value="">Select Year</option>
                    {pastWebinarYears.map((years) => (
                        <option key={years.year} value={years.year}>
                        {years.display_year}
                        </option>
                    ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">{errors.year}</Form.Control.Feedback>
                </Form.Group>
                
                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Webinar Title <small className='text-danger'> * </small></Form.Label>
                  <Form.Control type="text" name="webinar_title" value={form.webinar_title} onChange={handleChange}  isInvalid={!!errors.webinar_title}/>
                  <Form.Control.Feedback type="invalid">{errors.webinar_title}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Affilation <small className='text-danger'> * </small></Form.Label>
                  <Form.Control type="text" name="webinar_aff" value={form.webinar_aff} onChange={handleChange} isInvalid={!!errors.webinar_aff} />
                  <Form.Control.Feedback type="invalid">{errors.webinar_aff}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Youtube Code <small className='text-danger'> * </small> <small className="text-primary form-label-note">https://youtu.be/<mark>cvj0wcyK4Jo</mark></small></Form.Label>
                  <Form.Control type="text" name="webinar_code" value={form.webinar_code} onChange={handleChange}  isInvalid={!!errors.webinar_code}/>
                  <Form.Control.Feedback type="invalid">{errors.webinar_code}</Form.Control.Feedback>
                </Form.Group>
                {form.webinar_code && (
                  <div className="mt-3 rounded">
                    <label className="form-label form-label-custom">Video Preview:</label>
                    <div style={{
                      width: '300px',
                      height: '170px',
                      overflow: 'hidden',
                      borderRadius: '12px',
                      border: '1px solid #ccc',
                    }}>
                      <iframe
                        width="100%"
                        height="100%"
                        src={`https://www.youtube.com/embed/${form.webinar_code}`}
                        title="YouTube video preview"
                        frameBorder="0"
                        style={{ borderRadius: '12px' }}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </div>
                  </div>
                )}
                </div>
              
            <Modal.Footer className='border-0'>
              <Button variant="secondary" onClick={() => setShowModal(false)}> Cancel </Button>
              <Button variant="primary" onClick={handleSubmit}> {modalType === 'add' ? 'Add' : 'Save'} </Button>
            </Modal.Footer>
            </Form>
            </Modal.Body>
          </Modal>

          {/* Delete Confirmation Modal */}
          <Modal show={showDeleteConfirmModal} onHide={() => setShowDeleteConfirmModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to delete this row?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowDeleteConfirmModal(false)}>
                Cancel
              </Button>
              <Button variant="danger" onClick={handleDelete}>
                Yes, Delete
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <Footer />
        </div>
        )}
      </div>
    </div>
  );
};

export default Videosgallery;